import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import Image from "next/legacy/image";

function ThumbnailPlugin(mainRef) {
  return (slider) => {
    function removeActive() {
      slider.slides.forEach((slide) => {
        slide.classList.remove("active");
      });
    }
    function addActive(idx) {
      slider.slides[idx].classList.add("active");
    }

    function addClickEvents() {
      slider.slides.forEach((slide, idx) => {
        slide.addEventListener("click", () => {
          if (mainRef.current) mainRef.current.moveToIdx(idx);
        });
      });
    }

    slider.on("created", () => {
      if (!mainRef.current) return;
      addActive(slider.track.details.rel);
      addClickEvents();
      mainRef.current.on("animationStarted", (main) => {
        removeActive();
        const next = main.animator.targetIdx || 0;
        addActive(main.track.absToRel(next));
        slider.moveToIdx(next);
      });
    });
  };
}

const GallerySliderWithThumbnail = ({ images }) => {
  const [sliderRef, instanceRef] = useKeenSlider({
    initial: 0,
    slides: images.length,
  });
  const [thumbnailRef] = useKeenSlider(
    {
      initial: 0,
      slides: {
        perView: 4,
        spacing: 10,
      },
    },
    [ThumbnailPlugin(instanceRef)]
  );

  return (
    <>
      <div ref={sliderRef} className="keen-slider">
        {images.map((src, idx) => (
          <div
            key={idx}
            className="keen-slider__slide relative h-full w-full number-slide"
          >
            <Image
              src={src}
              alt="Slider Image"
              layout="fill"
              quality={100}
              objectFit="cover"
              priority
            />
          </div>
        ))}
      </div>

      <div
        ref={thumbnailRef}
        className="keen-slider thumbnail ml-3 overflow-x-auto"
      >
        {images.map((src, idx) => (
          <div key={idx} className="keen-slider__slide relative h-full w-full">
            <Image
              src={src}
              alt="Slider Image"
              layout="fill"
              quality={100}
              objectFit="cover"
              priority
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default GallerySliderWithThumbnail;
